import React, { useEffect, useState } from 'react';

interface TronWebProviderProps {
  children: React.ReactNode;
}

export const TronWebProvider: React.FC<TronWebProviderProps> = ({ children }) => {

  useEffect(() => {
    const initializeTronWeb = async () => {
      try {
        // Wait for TronWeb to be available
        const checkTronWeb = () => {
          return typeof (window as any).TronWeb !== 'undefined';
        };

        // Wait up to 15 seconds for TronWeb to load
        let attempts = 0;
        const maxAttempts = 150;

        while (!checkTronWeb() && attempts < maxAttempts) {
          await new Promise(resolve => setTimeout(resolve, 100));
          attempts++;
        }

        if (checkTronWeb()) {
          console.log('TronWeb is ready');

          // Check if TronWebProto is available, if not, we'll handle it gracefully
          if (typeof (globalThis as any).TronWebProto === 'undefined') {
            console.warn('TronWebProto is not available. Some TronWeb features may not work properly.');
          }
        } else {
          console.error('TronWeb failed to load after 15 seconds');
        }
      } catch (error) {
        console.error('Error initializing TronWeb:', error);
      }
    };

    // Add a small delay to ensure the script has time to load
    const timer = setTimeout(() => {
      initializeTronWeb();
    }, 100);

    return () => clearTimeout(timer);
  }, []);

  return <>{children}</>;
};
